<h1 mat-dialog-title class="notification-title">
	{{ 'insights.administration.reports.externalurl.title' | translate }}
</h1>
<mat-dialog-content [formGroup]="form">
	<div style="display: flex">
		<div class="example-container">
			<h5 class="mat-caption">
				{{ 'insights.administration.reports.externalurl.subtitle' | translate }}
			</h5>
			<form [formGroup]="form">
				<mat-label class="mat-subtitle-2">
					{{ 'insights.administration.reports.externalurl.inputname.label' | translate }}
				</mat-label>
				<div class="error-label mat-subtitle-2">
					@if (nameError) {
						<mat-error style="margin-left: auto">
							{{ 'insights.administration.reports.externalurl.inputname.error' | translate }}
						</mat-error>
					}
				</div>
				<mat-form-field appearance="outline" class="dialog">
					<input type="text" required matInput autofocus [placeholder]="'insights.administration.reports.externalurl.inputname.placeholder' | translate" [formControl]="nameControl" (input)="alphaNumberOnly($event)" (paste)="onPaste($event)" (keypress)="alphaNumberOnly($event)" maxlength="60" />
				</mat-form-field>
				<mat-label class="mat-subtitle-2">
					{{ 'insights.administration.reports.externalurl.inputurl.label' | translate }}
				</mat-label>
				<div class="error-label mat-subtitle-2">
					@if (urlError) {
						<mat-error style="margin-left: auto">
							{{ 'insights.administration.reports.externalurl.inputurl.error' | translate }}
						</mat-error>
					}
				</div>
				<mat-form-field appearance="outline" class="dialog">
					<input type="text" matInput required [placeholder]="'insights.administration.reports.externalurl.inputurl.placeholder' | translate" [formControl]="urlControl" />
				</mat-form-field>
			</form>
		</div>
	</div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">
		{{ 'insights.administration.reports.externalurl.cancelbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" cdkFocusInitial (click)="saveExtUrl()">
		{{ 'insights.administration.reports.externalurl.savebtn' | translate }}
	</button>
</div>
